import { isOrganizationAdmin, isProductCollaborator, isProductExecutive, type Role } from "@packages/core/session/roles.ts";

export const OFFICEVIBE_ANALYTICS_ACCESS: readonly Role[] = [isProductExecutive("wov")];

export const ONBOARDING_SURVEY_SETTINGS_ACCESS: readonly Role[] = [...OFFICEVIBE_ANALYTICS_ACCESS, isOrganizationAdmin];

export const ENGAGEMENT_ANALYTICS_ACCESS: readonly Role[] = [...OFFICEVIBE_ANALYTICS_ACCESS, isProductCollaborator("wov")];

export const PERFORMANCE_ANALYTICS_ACCESS: readonly Role[] = [isProductExecutive("wpm")];

export const ANALYTICS_ACCESS: readonly Role[] = [...ENGAGEMENT_ANALYTICS_ACCESS, ...PERFORMANCE_ANALYTICS_ACCESS];
